/** @jsxImportSource solid-js */
import type { JSX } from "solid-js";
import { WORDMARK_HTML } from "../styles/widget-brand";

export function WidgetWordmark(): JSX.Element {
  return (
    <span
      class="inline-flex items-center gap-[.4em] font-normal tracking-[-0.028em] whitespace-nowrap [&_b]:font-bold"
      innerHTML={WORDMARK_HTML}
    />
  );
}
